
import { Vue, Component, Prop } from "vue-property-decorator";

interface SupportNetworkData {
  family_support: string;
  social_connections: string;
  community_resources: string;
  professional_care_contacts: string;
}

@Component
export default class SupportNetwork extends Vue {
  @Prop({ required: true }) readonly data!: SupportNetworkData;
}
